export default __webpack_public_path__ + "static/media/copyOutlined.72399143.svg";